// @ts-nocheck
import React from "react";
import { TabsUsuarios } from "./Componentes/TabsUsuarios";
import { ProvideUsuarios } from "./State/ProvideUsuarios";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import SinapThemev2 from '../styles/SinapThemev2';
import Keycloak from "../Auth/Keycloak";
import { FormularioAlta } from "./FormularioAlta";
import { ACCESO_USUARIOS } from "../Contantes/Constantes";
import { ProvideFormulario } from "./State/FormularioState/ProvideFormulario";
import { useAuth } from "../Auth/State/AuthContext";



export const AltaUsuarios = () => {
    const { hasRole } = useAuth();
    const searchParams = new URLSearchParams(document.location.search);

    return (
        <ProvideUsuarios>
            <ProvideFormulario>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={SinapThemev2}>
                        <TabsUsuarios />
                    </ThemeProvider>
                </StyledEngineProvider>
            </ProvideFormulario>
        </ProvideUsuarios>
    );
}
